import { Type } from "@sinclair/typebox";
export const ChatflowStartedSchema = Type.Object({
    conversation_id: Type.String(),
    chatflow_id: Type.String(),
});
export const ChatflowEndedSchema = Type.Object({
    conversation_id: Type.String(),
    chatflow_id: Type.String(),
    completed_at: Type.String({ format: "date-time" }),
    failed: Type.Boolean(),
});
